import { CollectionKeys } from "constants/product-collection";
import { ISchemaKey } from "helpers/product-collection";
import { List, Map } from "immutable";
import { BACKEND_EXPECTED_OPERATION } from "../collection-item-display-property";

const schemaKeyListToOverridableReducer = (
    acc: Map<string, Map<keyof ISchemaKey, any>>,
    schemaKey: Map<keyof ISchemaKey, any>,
) => (schemaKey.get("allow_override_display_name") ? acc.set(schemaKey.get("field_name"), schemaKey) : acc);

export const makeOverrideDisplayNamePayload = (
    prevSnapshot: Map<string, any>,
    currentItemsList: List<Map<keyof ISchemaKey, any>>,
) => {
    const schemaList = prevSnapshot.getIn(CollectionKeys.ITEM_DISPLAY_PROPERTY.KEYS) as List<
        Map<keyof ISchemaKey, any>
    >;

    const overridableSchemas = schemaList.reduce(schemaKeyListToOverridableReducer, Map());

    const schemaKeyToSend = currentItemsList.find(
        (value) =>
            overridableSchemas.has(value.get("field_name")) &&
            !(
                overridableSchemas.get(value.get("field_name")).get("display_name_override") ===
                value.get("display_name_override")
            ),
    );
    return {
        [BACKEND_EXPECTED_OPERATION]: {
            field_name: schemaKeyToSend.get("field_name"),
            display_name_override: schemaKeyToSend.get("display_name_override"),
        },
    };
};
